<template>
  <div class="bg-secondary-1 py-2 px-2 board-radius">
    <div id="providerInfoRef" class="bg-white rounded p-2">
      <div class="row p-2">
        <div class="col-md-6 col-sm-12">
          <div class="d-flex">
            <em class="pt-1 mr-2 text-orange fas fa-address-book" />
            <div>
              <span class="font-12 color-gray-6">Nombre del Proveedor:</span>
              <p class="font-14 color-black">{{ model.companyName }}</p>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-sm-12">
          <div class="d-flex">
            <em class="pt-1 mr-2 text-orange fas fa-address-book" />
            <div>
              <span class="font-12 color-gray-6">Tipo de Proveedor:</span>
              <p class="font-14 color-black">{{ model.companyTypeName }}</p>
            </div>
          </div>
        </div>

        <div class="col-md-2 col-sm-12">
          <div class="d-flex">
            <em class="pt-1 mr-2 text-orange fas fa-address-book" />
            <div>
              <span class="font-12 color-gray-6">SSN Patronal:</span>
              <template v-if="!editMode">
                <p class="font-14 color-black">{{ model.ssn }}</p>
              </template>
              <template v-else>
                <ValidationObserver ref="providerInfoRef" v-slot="{ validate }">
                  <ValidationProvider
                    v-slot="{ errors, failedRules }"
                    name="ssn"
                    rules="required"
                  >
                    <div class="d-flex align-items-center">
                      <CustomInput
                        v-model="model.ssn"
                        custom-error-msg=""
                        :error="errors[0]"
                        mask-type="SSNPatronal"
                        placeholder="Escriba SSN Patronal"
                        type="text"
                      />
                      <ActionButton
                        class="btn-action-size ml-2"
                        i="fas fa-save"
                        variant="outline-success"
                        @click="submitForm(validate)"
                      />
                      <ActionButton
                        class="btn-action-size ml-2"
                        i="fas fa-ban"
                        variant="outline-danger"
                        @click="cancelEdit"
                      />
                    </div>
                    <Error
                      v-if="failedRules.required"
                      message="El SSN es requerido."
                      variant="no-border"
                    />
                  </ValidationProvider>
                </ValidationObserver>
              </template>
            </div>
          </div>
        </div>

        <div class="col-md-1 col-sm-12">
          <ActionButton
            v-if="canEditSsn && !editMode"
            class="btn-action-size"
            i="fas fa-edit"
            variant="outline-success"
            @click="editMode = true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import Error from 'custom-error';
import { editHeaderInfo } from '@/modules/provider/api';
import alert from '@/mixins/alert.mixin';

export default {
  name: 'ProviderHeaderInfo',
  components: {
    ValidationProvider,
    ValidationObserver,
    CustomInput,
    ActionButton,
    Error,
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    companyId: {
      type: Number,
      required: true,
    },
    canEditSsn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: { ...this.value },
      editMode: false,
    };
  },
  watch: {
    value(newValue) {
      this.model = { ...newValue };
    },
  },
  methods: {
    cancelEdit() {
      this.model.ssn = this.value.ssn;
      this.editMode = false;
    },
    async submitForm(validate) {
      const isValid = await validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      let model = { id: this.companyId, ssn: this.model.ssn };
      try {
        await editHeaderInfo(model);
        this.ShowToast(
          'Confirmación',
          'La información del proveedor ha sido actualizada exitosamente.',
          'success'
        );
        this.editMode = false;
      } catch (error) {
        const err =
          error.response?.data?.message || 'Error al guardar la información.';
        this.ShowToast('Alerta', err, 'error');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.w-74 {
  width: 74%;
}
</style>
